var Endpoint;
(function (Endpoint) {
    Endpoint["ChangeProject"] = "rest/system/change_project";
    Endpoint["EmployeesAccess"] = "rest/employees/access";
    Endpoint["UserAccess"] = "rest/users/access";
    Endpoint["Counters"] = "rest/system/counters";
    Endpoint["AccountStatus"] = "rest/users/account-status";
    Endpoint["AppFunctions"] = "rest/functions";
    Endpoint["FunnelStages"] = "rest/funnel/stages";
})(Endpoint || (Endpoint = {}));
export default Endpoint;
